module.exports = __webpack_public_path__ + "static/whyarewedoingthis-8d285ff70788b68009bdfefb2e8523bd.gif";